import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=2d7fe0f6"
import script from "./QRCode.vue?vue&type=script&lang=ts"
export * from "./QRCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports